var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create-rule"},[_c('Triggers',{attrs:{"editTrigger":_vm.ruleData},on:{"conditionalOptions":_vm.condicionalOptions}}),_c('Conditions',{attrs:{"editConditions":_vm.editConditions,"conditionsData":_vm.optionsConditions}}),_c('Actions',{attrs:{"editActions":_vm.editActions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }